// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import Autocomplete from 'react-google-autocomplete';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import moment from 'moment-timezone';
import TimePicker from '../../utils/FormWidgets/TimePicker';
import DatePicker from '../../utils/FormWidgets/DatePicker';
import Rq from '../../utils/FormWidgets/RequireField';
import { setTopPosition } from '../../utils/Styles/SetTopPosition';
import { getLocationDescription } from '../../../infrastructure/utils/common';

export default class LodgingForm extends React.Component {
  instanceName = React.createRef();
  instanceAdress = React.createRef();

  componentDidUpdate() {
    if (!this.instanceName.current || !this.instanceAdress.current) {
      return;
    }

    this.onFocus();
  }

  onFocus = () => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.instanceName.current.addEventListener('focusin', () => {
      setTopPosition('.pac-container', this.instanceName);
    });
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.instanceAdress.current.addEventListener('focusin', () => {
      setTopPosition('.pac-container', this.instanceAdress);
    });
  };

  handleActivityChange = val => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleLocalDataChange, event } = this.props;
    handleLocalDataChange({
      ...event,
      activityId: val,
    });
  };

  handleNameChange = ({ target }) => {
    setTopPosition('.pac-container', this.instanceName);
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleTravelDataChange, event } = this.props;
    handleTravelDataChange({
      ...event,
      eventName: target.value,
    });
  };

  locationSelected = async val => {
    if (val.place_id === undefined) {
      return;
    }
    let image;
    const location = await getLocationDescription(val, true);
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleTravelDataChange, event } = this.props;
    if (val.photos) {
      image = {
        url: val.photos[0].getUrl(),
      };
      handleTravelDataChange({
        ...event,
        eventLocation: location,
        image,
      });
    }
  };

  locationChanged = ({ target }) => {
    setTopPosition('.pac-container', this.instanceAdress);
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleTravelDataChange, event } = this.props;
    const newLocation = {
      address: target.value.length > 0 ? target.value : undefined,
    };
    handleTravelDataChange({
      ...event,
      eventLocation: newLocation,
      image: undefined,
    });
  };

  handleCheckoutDateChange = value => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { handleTravelDataChange, event } = this.props;
    if (!value) {
      handleTravelDataChange({
        ...event,
        startTime: -1,
        endTime: -1,
        eventDate: value,
        checkoutDate: value,
        timeTBD: true,
        dateTBD: true,
      });

      return;
    }
    handleTravelDataChange({
      ...event,
      checkoutDate: value,
      dateTBD: false,
    });
  };

  render() {
    const {
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      labels,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      event,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      handleDateChange,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      startDate,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      endDate,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      disabledDays,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      TBDTime,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      handleStartTimeChange,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      handleEndTimeChange,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      placeSelected,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      tz,
    } = this.props;
    return (
      <Fragment>
        <FormGroup controlId='eventName'>
          <ControlLabel>
            Venue Name
            <Rq />
          </ControlLabel>
          {
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            <div ref={this.instanceName}>
              {
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                <Autocomplete
                  className='form-control'
                  types={['establishment']}
                  onPlaceSelected={placeSelected}
                  onChange={this.handleNameChange}
                  // TODO: Fix this the next time the file is edited.
                  // eslint-disable-next-line react/prop-types
                  value={event.eventName}
                />
              }
            </div>
          }
        </FormGroup>
        <FormGroup controlId='eventName'>
          <ControlLabel>
            Address
            <Rq />
          </ControlLabel>
          {
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            <div ref={this.instanceAdress}>
              {
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                <Autocomplete
                  className='form-control'
                  types={['establishment']}
                  onPlaceSelected={this.locationSelected}
                  onChange={this.locationChanged}
                  value={
                    // TODO: Fix this the next time the file is edited.
                    // eslint-disable-next-line react/prop-types
                    event.eventLocation && event.eventLocation.address // TODO: Fix this the next time the file is edited.
                      ? // eslint-disable-next-line react/prop-types
                        event.eventLocation.address
                      : ''
                  }
                />
              }
            </div>
          }
        </FormGroup>
        <div className='row'>
          <div className='day-picker-inp col-md-6 col-sm-6'>
            <FormGroup controlId='checkinDate'>
              <DatePicker
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                setUtc={false}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/prop-types
                label={labels.FromDateLabel}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/prop-types
                value={event.eventDate}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/prop-types
                placeholder={event.dateTBD && event.timeTBD ? 'TBD' : ''}
                handleChange={handleDateChange}
                dayPickerProps={{
                  initialMonth: moment(startDate).tz(tz).toDate(),
                  modifiers: {
                    disabled: [
                      {
                        daysOfWeek: disabledDays,
                      },
                      {
                        before: moment(startDate).tz(tz).toDate(),
                        after: moment(endDate).tz(tz).toDate(),
                      },
                    ],
                  },
                }}
              />
            </FormGroup>
          </div>
          <FormGroup controlId='checkinTime' className='col-md-4 col-sm-4'>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            <ControlLabel>{labels.FromTimeLabel}</ControlLabel>
            <TimePicker
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              onChange={handleStartTimeChange}
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/prop-types
              placeholder={event.dateTBD && event.timeTBD ? 'TBD' : ''}
              tbd={TBDTime}
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/prop-types
              value={event.startTime}
            />
          </FormGroup>
        </div>
        <div className='row'>
          <div className='day-picker-inp col-md-6 col-sm-6'>
            <FormGroup controlId='checkoutDate'>
              <DatePicker
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                setUtc={false}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/prop-types
                label={labels.ToDateLabel}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/prop-types
                value={event.checkoutDate}
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/prop-types
                placeholder={event.dateTBD && event.timeTBD ? 'TBD' : ''}
                handleChange={this.handleCheckoutDateChange}
                dayPickerProps={{
                  initialMonth: moment(startDate).tz(tz).toDate(),
                  modifiers: {
                    disabled: [
                      {
                        daysOfWeek: disabledDays,
                      },
                      {
                        before: moment(startDate).tz(tz).toDate(),
                        after: moment(endDate).tz(tz).toDate(),
                      },
                    ],
                  },
                }}
              />
            </FormGroup>
          </div>
          <FormGroup controlId='checkoutTime' className='col-md-4 col-sm-4'>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            <ControlLabel>{labels.ToTimeLabel}</ControlLabel>
            <TimePicker
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              onChange={handleEndTimeChange}
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/prop-types
              placeholder={event.dateTBD && event.timeTBD ? 'TBD' : ''}
              tbd={TBDTime}
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/prop-types
              value={event.endTime}
            />
          </FormGroup>
        </div>
      </Fragment>
    );
  }
}
